import ax from '../axios'
import {IClassroom, IClassroomCurriculum, ID} from "../../constants";
import {API_URL} from "../index";

const SCHOOL_RECOMMENDATION_URL = API_URL.EDUCATION_MODULE + '/school-recommendation'
const SCHOOL_URL = API_URL.EDUCATION_MODULE + '/school'

const createSchool = (classroom: IClassroom) => {
    delete classroom.id
    return ax.post(SCHOOL_RECOMMENDATION_URL, classroom)
}

const getSchoolById = (id: ID) => {
    return ax.get(`${SCHOOL_URL}/${id}`)
}

export {
    createSchool,
    getSchoolById
}
